import { IniciarMandatoPat, ValidarMandatoPat, ObtenerBancosGPA, IniciarMandatoPac, TieneMandatoPac, ObtenerDatosAlumno, ObtieneComprobante, InsertarMandatoPat, TieneMandatoPat } from "../../../application/interactors/PacPat";

export const IniciarMandatoPatLogic = (selIniciarMandato: any, rut: number, codigoNegocio: number, codigoPrograma: string, codigoPlanificacionAcademica: number, agnoProceso: number) => {
    return IniciarMandatoPat(selIniciarMandato, rut, codigoNegocio, codigoPrograma, codigoPlanificacionAcademica, agnoProceso);
};
export const ValidarMandatoPatLogic = (selValidarMandato: any, token: string, rutAlumno: number, codPrograma: string) => {
    return ValidarMandatoPat(selValidarMandato, token, rutAlumno, codPrograma);
}
export const ObtenerBancosGPALogic = (selListBancos: any) => {
    return ObtenerBancosGPA(selListBancos);
}
export const IniciarMandatoPacLogic = (selIniciarMandato: any, data: any) => {
    return IniciarMandatoPac(selIniciarMandato, data);
};
export const InsertarMandatoPatLogic = (selIniciarMandato: any, data: any) => {
    return InsertarMandatoPat(selIniciarMandato, data);
};
export const TieneMandatoPacLogic = (selTieneMandato: any, codCarrera: string, rutAlumno: number, tipoMandato: number, tipoOrigen: number) => {
    return TieneMandatoPac(selTieneMandato, codCarrera, rutAlumno, tipoMandato, tipoOrigen);
};
export const TieneMandatoPatLogic = (selTieneMandato: any, codCarrera: string, rutAlumno: number, tipoMandato: number, tipoOrigen: number) => {
    return TieneMandatoPat(selTieneMandato, codCarrera, rutAlumno, tipoMandato, tipoOrigen);
};
export const ObtenerDatosAlumnoLogic = (selListAlumno: any, rut: number, codCarrera: string, esFormularioPAC: boolean = false) => {
    return ObtenerDatosAlumno(selListAlumno, rut, codCarrera, esFormularioPAC);
}
export const ObtieneComprobanteLogic = (selListComprobante: any, codCarrera: string, rutAlumno: number, tipoMandato: number, tipoOrigen: number) => {
    return ObtieneComprobante(selListComprobante, codCarrera, rutAlumno, tipoMandato, tipoOrigen);
}